import { Form, FormInstance, Input } from 'antd';

import { txt } from '../../../../locales/i18n';

export type CarouselPanelProps = {
	propertyKey: string;
	formRef: React.RefObject<FormInstance>;
	onSectionChange: (changedValues: any, values: any) => void;
};

export const CarouselPanel = (props: CarouselPanelProps) => (
	<div>
		<label>{txt('cms.arrow color')}</label>
		<Form.Item name={[props.propertyKey, 'arrowColor']}>
			<Input type="color" />
		</Form.Item>
	</div>
);
